import DOMPurify from 'dompurify';
import React from 'react';
import { Props } from '../container';
import {
  Autocomplete,
  Box,
  Card,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { WO2Select } from 'src/common';

export const ReportingEmailTemplate = (props: Props): JSX.Element => {
  if (!props.batch.bulkReport.emailParameters) {
    return <Typography>An email template has not been configured for this bulk report.</Typography>;
  }

  const { fromEmailAddressType, ccEmailAddressTypes, subject, body } = props.batch.bulkReport.emailParameters;
  return (
    <Card elevation={3} sx={{ padding: 2 }}>
      <Grid item container direction="column" spacing={2} padding={1}>
        <Grid item>
          <FormControl fullWidth>
            <InputLabel id="from">From Email Address</InputLabel>
            <WO2Select disabled labelId="from" label="From Email Address" value={fromEmailAddressType ?? ''}>
              <MenuItem value={fromEmailAddressType ?? ''}>{fromEmailAddressType ?? ''}</MenuItem>
            </WO2Select>
          </FormControl>
        </Grid>
        <Grid item>
          <Autocomplete
            multiple
            fullWidth
            disabled
            id="cc"
            options={ccEmailAddressTypes}
            value={ccEmailAddressTypes}
            getOptionLabel={(option) => option}
            renderInput={(params) => <TextField {...params} label="CC Email Address" margin="normal" fullWidth />}
            isOptionEqualToValue={(option, value) => option === value}
          />
        </Grid>
        <Grid item>
          <TextField fullWidth disabled variant="outlined" label="Subject" value={subject} />
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        <Grid item sx={{ color: 'rgba(0, 0, 0, 0.38)' }}>
          <Box
            sx={{
              width: '100%',
              padding: '16.5px 14px',
              border: '1px solid rgba(0,0,0,0.23)',
              borderRadius: '4px',
              fontSize: '16px',
              lineHeight: 1.5,
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body ?? '') }} />
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};
